export default __webpack_public_path__ + "static/media/gallery_03.38a9f393.jpg";